'use strict';
import React from 'react';
import {DataLoader} from "../../components/Input";

// 公司(os10010)
class OSCompanyPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/os/options/companies',
		placeholder: '請選擇公司...',
		renderTag: d => <>{d.name} <small>({d.code})</small></>,
		renderItem: (d, idx) => <>
			{idx !== undefined ? <small className={'color-lightGray'}>{idx + 1}. </small> : ''}
			{d.name}
			<span className={'extra'}>{d.code}</span>
		</>,
	};
}

// 扣繳單位(os10020)
class OSSNOPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/os/options/${bid}/SNOs`,
		placeholder: '扣繳單位(統編)',
		renderTag: d => <>{d.name} <span className={'extra'}>{d.no}</span></>,
		renderItem: d => <>{d.name} <span className={'extra'}>{d.no}</span></>,
	};
}

// 勞保投保單位(os10030)
class OSLaborNoPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/os/options/${bid}/laborNo`,
		placeholder: '勞保投保單位',
		renderItem: d => <>{d.name} <span className={'extra'}>{d.code}</span></>,
		renderTag: d => <>{d.name} <span className={'extra'}>{d.code}</span></>,
	};
}

// 健保投保單位(os10040)
class OSHNOPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/os/options/${bid}/HNOs`,
		placeholder: '健保投保單位',
		renderItem: d => <>{d.name} <span className={'extra'}>{d.code}</span></>,
		renderTag: d => <>{d.name} <span className={'extra'}>{d.code}</span></>,
	};
}

// 組織類別(os90020)
class OSOrgTypePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/os/options/${bid}/orgTypes`,
		placeholder: '組織類別',
		filter: d => {
			return d.name && d.countIsEff;
		},
		renderItem: d => d.name,
	};
}
class OSOrgTypePicker2 extends OSOrgTypePicker {
	getValue() {
		const v1 = super.getValue();
		return this.state.data?.find(v2 => v2.id == v1)?.code || v1;
	}
}

// 組織圖 (os20030)
class OSOrgTypeChartPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/os/options/${bid}/orgTypeChart`,
		placeholder: '組織類別',
		filter: d => {
			return d.name && d.countIsEff;
		},
		renderItem: d => d.name,
	};
}

// 部門層級(LevelHandlePanel)
class OSDeptLevelPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/os/options/${bid}/deptLevels`,
		placeholder: '部門層級',
	};
}

//部門新增
class OSDepPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/os/options/${bid}/depts`,
		placeholder: '部門',
	};
}

export {
	OSCompanyPicker,
	OSSNOPicker,
	OSLaborNoPicker,
	OSHNOPicker,
	OSOrgTypePicker, OSOrgTypePicker2,
	OSDeptLevelPicker,
	OSDepPicker, OSOrgTypeChartPicker
};
